import { Pronosticsv2ListAdminView } from "pronosticsv2/admin/views/Pronosticsv2ListAdminView";
import { Route, Routes } from "react-router-dom";
import { Pronosticv2AdminView } from "pronosticsv2/admin/views/Pronosticv2AdminView";
import { Pronosticv2DeleteAdminView } from "pronosticsv2/admin/views/Pronosticv2DeleteAdminView";
import { Pronosticv2TestPageView } from "pronosticsv2/admin/views/Pronosticv2TestPageView";
export function Pronosticsv2AdminRoutes() {
  return (
    <Routes>
      <Route path="" element={<Pronosticsv2ListAdminView />} />
      <Route path="new" element={<Pronosticv2AdminView />} />
      <Route path=":pronosticsv2Id">
        <Route path="" element={<Pronosticv2AdminView />} />
      </Route>
      <Route path=":pronosticsv2Id/duplicate">
        <Route path="" element={<Pronosticv2AdminView />} />
      </Route>
      <Route path="delete" element={<Pronosticv2DeleteAdminView />} />
      <Route path="testpage" element={<Pronosticv2TestPageView />} />
    </Routes>
  );
}
